/**
 * 상품별 티켓 가이드 설정 데이터
 * analysisTypeId별로 아코디언 가이드 UI에 필요한 헤더/바디 데이터를 정의
 */

// ─── 신년운세 (analysisTypeId: 9) ────────────────────────────
const yearlyFortuneGuide = {
  headerBg: '#fff8f5',
  accentColor: '#eb4c10',
  sections: [
    {
      type: '1회권',
      desc: '신년 · 구정 시즌, 나를 위한 한 해 정리',
      discountRate: '15%',
      bodyHtml: `
        <div class="body-top">
          <p class="body-title">나를 위한 한 해의 흐름을 정리하는 시간</p>
          <p class="body-desc">
            새해의 첫 마음에서 명절을 앞둔 지금까지,<br>
            한 해의 흐름을 차분히 돌아보기 좋은 시점입니다.
          </p>
        </div>
        <div class="body-bottom">
          <p class="body-title">나를 위한 선택에 부담이 없도록</p>
          <p class="body-highlight">
            1회 구성에는 <span class="discount-badge">15%</span> 혜택을 담았습니다.
          </p>
        </div>
      `,
    },
    {
      type: '2회권',
      desc: '둘이 함께보면 더 잘 보이는 한 해',
      discountRate: '25%',
      bodyHtml: `
        <div class="body-top">
          <p class="body-title">가장 가까운 사람과 흐름을 나누는 구성</p>
          <p class="body-desc">
            서로의 한 해를 조금 더 이해하면<br>
            대화의 방향도 자연스럽게 달라집니다.
          </p>
        </div>
        <div class="body-bottom">
          <p class="body-title">가장 가까운 한 사람과 함께 보고싶다는 마음을 담아</p>
          <p class="body-highlight">
            더 여유있는 <span class="discount-badge">25%</span> 혜택을 준비했어요.
          </p>
        </div>
      `,
    },
    {
      type: '3회권',
      desc: '가족의 한 해를 한 번에 살펴보는 구성',
      discountRate: '40%',
      bodyHtml: `
        <div class="body-top">
          <p class="body-title">가족의 한 해 흐름을 함께 살펴보는 구성</p>
          <p class="body-desc">
            가족 구성원의 흐름을 한 자리에서 살펴보며<br>
            올 한 해의 방향을 함께 그려볼 수 있습니다.
          </p>
        </div>
        <div class="body-bottom">
          <p class="body-title">함께보는 신년운세의 의미를 담아</p>
          <p class="body-highlight">
            3인 구성에는 가장 큰 <span class="discount-badge">40%</span> 혜택을 준비했어요.
          </p>
        </div>
      `,
    },
  ],
}

// ─── 택일 집중 (analysisTypeId: 13) ─────────────────────────
const choiceConcentratedGuide = {
  headerBg: 'rgba(127, 176, 105, 0.1)',
  accentColor: '#64a348',
  sections: [
    {
      type: '택일 집중',
      desc: '이유까지 자세히 설명해주는 택일 해석',
      discountRate: null,
      bodyHtml: `
        <div class="body-top">
          <p class="body-title">
            중요한 날인 만큼 이유를 꼼꼼히<br>
            확인하고 싶을 때 좋아요.
          </p>
          <p class="body-desc">
            중요한 일이라 한 번 더 생각해보고 싶은 날,<br>
            이유까지 자세히 알려주는 택일해석 입니다.
          </p>
        </div>
        <div class="body-bottom">
          <p class="body-title">특정 날짜만 보고싶다면 맞춤택일에서</p>
          <p class="body-highlight">
            <span class="accent-text">[ 집중분석 → 1일 ]</span> 을 선택하시면
          </p>
          <p class="body-title">해당 날짜를 확인할 수 있습니다.</p>
        </div>
      `,
    },
    {
      type: '7일',
      desc: '특정 구간만 보고 싶을 때',
      discountRate: null,
      bodyHtml: `
        <div class="body-top">
          <p class="body-title">중요한 일정 전, 가장 많이 선택돼요.</p>
          <p class="body-desc">
            며칠을 비교해보고 결정해야 할 때,<br>
            가장 균형있는 선택이에요.
          </p>
        </div>
        <div class="body-bottom">
          <p class="body-title">분석권으로 2개이상 구매하시는</p>
          <p class="body-highlight">
            분들을 위해 <span class="discount-badge">~35%</span> 혜택을 준비했습니다.
          </p>
        </div>
      `,
    },
    {
      type: '30일',
      desc: '한달을 집중적으로 보고 싶을 때',
      discountRate: null,
      bodyHtml: `
        <div class="body-top">
          <p class="body-title">
            한달 흐름을 한 번에<br>
            여러번 볼 계획이라면 합리적이예요.
          </p>
          <p class="body-desc">
            한 달 전체 리듬을 보면서<br>
            일정들을 여유있게 배치할 수 있어요.
          </p>
        </div>
        <div class="body-bottom">
          <p class="body-title">분석권으로 여러 개 구매하시는 분들을 위해</p>
          <p class="body-highlight">
            더욱 특별한 <span class="discount-badge">~60%</span> 혜택을 준비했어요.
          </p>
        </div>
      `,
    },
  ],
}

// ─── 택일 라이트 (analysisTypeId: 14) ───────────────────────
const choiceLightGuide = {
  headerBg: 'linear-gradient(to right, #ffe0d8, #c5daff)',
  accentColor: '#ff5d5d',
  sections: [
    {
      type: '택일 라이트',
      desc: '빠르게 일정 참고가 필요할 때',
      discountRate: null,
      bodyHtml: `
        <div class="body-top">
          <p class="body-title">
            중요한 기간의 흐름을<br>
            한 눈에 보고 싶을 때 좋아요.
          </p>
          <p class="body-desc">
            원하는 주간의 흐름이나 한 달의 전체 리듬을<br>
            가볍게 살펴볼 수 있는 택일해석입니다.
          </p>
        </div>
        <div class="body-bottom">
          <p class="body-title">특정 기간의 흐름을 보고싶다면 맞춤택일에서</p>
          <p class="body-highlight">
            <span class="accent-text">[ 라이트분석 → 원하는 기간 ]</span> 을 선택하시면
          </p>
          <p class="body-title">해당 날짜를 확인할 수 있습니다.</p>
        </div>
      `,
    },
    {
      type: '7일',
      desc: '특정 기간의 흐름을 보고 싶을 때',
      discountRate: null,
      bodyHtml: `
        <div class="body-top">
          <p class="body-title">빠르게 확인하고 싶을 때!</p>
          <p class="body-desc">
            설명은 생략하고, 일주일간의<br>
            흐름과 결과를 빠르게 보고 싶다면
          </p>
        </div>
        <div class="body-bottom">
          <p class="body-title">분석권으로 2개이상 구매하시는</p>
          <p class="body-highlight">
            분들을 위해 <span class="discount-badge">27%</span> 혜택을 준비했습니다.
          </p>
        </div>
      `,
    },
    {
      type: '30일',
      desc: '한 달 전체의 흐름을 보고 싶을 때',
      discountRate: null,
      bodyHtml: `
        <div class="body-top">
          <p class="body-title">부담없이 한 달의 흐름을 가볍게 체크!</p>
          <p class="body-desc">
            달력에서 한 달 흐름을 한 눈에 보고<br>
            결정만 빠르게하고 싶을 때 좋아요.
          </p>
        </div>
        <div class="body-bottom">
          <p class="body-title">분석권으로 여러 개 구매하시는 분들을 위해</p>
          <p class="body-highlight">
            더욱 특별한 <span class="discount-badge">50%</span> 혜택을 준비했어요.
          </p>
        </div>
      `,
    },
  ],
}

// ─── 낭만궁합 (analysisTypeId: 38) ───────────────────────────
const nangmanHarmonyGuide = {
  headerBg: 'rgba(203, 81, 93, 0.1)',
  accentColor: '#d74251',
  sections: [
    {
      type: '1 / 2 회권',
      desc: '',
      discountRate: '25~35% 할인',
      bodyHtml: `
        <div class="body-top">
          <p class="body-title">
            새로 만난 사람과의 케미가 궁금할 때,<br>
            사랑하는 사람을 더 깊이 이해하고 싶을 때
          </p>
          <p class="body-desc">
            한 사람과 깊게 보거나, 주변 인연을<br>
            두번 나눠 차근차근 볼 수 있어요
          </p>
        </div>
        <div class="body-bottom">
          <p class="body-title accent-text">
            단권 25%, 2회권 35% 할인으로 가볍게 시작하는<br>
            1:1 궁합 분석 혜택을 만나보세요
          </p>
        </div>
      `,
    },
    {
      type: '3 / 5 회권',
      desc: '',
      discountRate: '45~55% 할인',
      bodyHtml: `
        <div class="body-top">
          <p class="body-title">
            여러 인연이 궁금해질 때,<br>
            주변 관계를 한 번에 살펴보고 싶을 때
          </p>
          <p class="body-desc">
            가까운 인연들을 한 사람씩 차근차근 분석하고,<br>
            여러 관계를 여유있게 볼 수 있어요
          </p>
        </div>
        <div class="body-bottom">
          <p class="body-title accent-text">
            3회 분석권이면 절반 가까이! 45% 알뜰하게!<br>
            5회 분석권은 반값에! 55% 실속있게!
          </p>
        </div>
      `,
    },
    {
      type: '10 회권',
      desc: '',
      discountRate: '65% 할인',
      bodyHtml: `
        <div class="body-top">
          <p class="body-title">
            가까운 인연들을 부담없이!<br>
            가격도 즐거운 이용권
          </p>
          <p class="body-desc">
            여러 인연을 차분히<br>
            이해하고 싶은 분께 좋아요!
          </p>
        </div>
        <div class="body-bottom">
          <p class="body-title accent-text">
            65% 할인 · 회당 1,100원대로<br>
            가장 알뜰하게 살펴보는 시간
          </p>
        </div>
      `,
    },
  ],
}

// ─── 용신궁합 패키지 (analysisTypeId: 41) ─────────────────────
const yongsinHarmonyPackageGuide = {
  headerBg: '#edf6ff',
  accentColor: '#eb4c10',
  rootClass: 'guide-yongsin-harmony-package',
  sections: [
    {
      titleHtml: `🎁 오픈 기념 <span class="accent-text">특별 패키지</span> 이벤트`,
      bodyHtml: `
        <div class="body-top">
          <p class="body-title">
            모르고 지나치기엔 아쉬운<br>
            <span style="font-size: 18px;">"나를 위한 명리 해석"</span>
          </p>
          <p class="body-desc">
            <span style="color: #5d81bf; font-weight: 800; font-size: 15px;">나를 도와주는 에너지</span>를 살피고<br>
            <span style="color: #df6772; font-weight: 800; font-size: 15px;">1:1 낭만궁합</span>으로 관계의 흐름까지
          </p>
        </div>
        <div class="body-bottom">
          <p class="body-title">두가지 매력을 한 번에 만나는</p>
          <p class="body-title">
            <span class="accent-text">[ 오픈 기념 특별 패키지 ]</span> 입니다
          </p>
        </div>
      `,
    },
    {
      titleHtml: `⭐ <span class="accent-text">알뜰한</span> 명리해석의 경험`,
      bodyHtml: `
        <div class="body-top">
          <p class="body-title">
            가장 많이 <span style="font-size: 18px;">요청해주신</span><br>
            <span style="font-size: 18px;">구성</span>을 담았습니다!
          </p>
          <p class="body-desc">
            오픈 패키지로 더욱 알뜰해진<br>
            나를 돕는 기운 + 1:1 낭만궁합
          </p>
        </div>
        <div class="body-bottom">
          <p class="body-highlight">
            <span class="discount-badge">35%</span> 할인된 특별 가격
          </p>
          <p class="body-title">오픈 이벤트 기간 한정으로 만나보세요!</p>
        </div>
      `,
    },
    {
      titleHtml: `💡<span class="accent-text">에너지의 발견</span>, 명료한 우리`,
      bodyHtml: `
        <div class="body-top">
          <p class="body-title">
            나의 에너지를 알면<br>
            <span style="font-size: 18px;">관계는 다르게 보입니다</span>
          </p>
          <p class="body-desc">
            다름을 이해하면<br>
            부딪힘도 줄어들죠!
          </p>
        </div>
        <div class="body-bottom">
          <p class="body-title">명리의 지혜로 짚어보는</p>
          <p class="body-highlight">
            <span class="discount-badge">자기발견</span> 의 시간을 가져보세요
          </p>
        </div>
      `,
    },
  ],
}

/**
 * analysisTypeId로 가이드 설정 조회
 * @param {number} analysisTypeId
 * @returns {Object|null}
 */
export const getTicketGuideConfig = (analysisTypeId) => {
  const configs = {
    9: yearlyFortuneGuide,
    13: choiceConcentratedGuide,
    14: choiceLightGuide,
    38: nangmanHarmonyGuide,
    '38,41': yongsinHarmonyPackageGuide,
  }
  return configs[analysisTypeId] || null
}
